import { render, staticRenderFns } from "./InstallationsSideviewFilesTab.vue?vue&type=template&id=8a2e6140&scoped=true&class=fill-height&"
import script from "./InstallationsSideviewFilesTab.vue?vue&type=script&lang=ts&"
export * from "./InstallationsSideviewFilesTab.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsSideviewFilesTab.vue?vue&type=style&index=0&id=8a2e6140&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2e6140",
  null
  
)

export default component.exports